var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLeak = function SvgLeak(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4246",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    fill: "none",
    stroke: "currentColor",
    transform: "translate(0 -1028.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path4805",
    cx: 12,
    cy: 1040.4,
    r: 5.163
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4836",
    strokeLinejoin: "round",
    d: "M5.088 1037.5c.413-1.149-.866-4.915-.866-4.915s3.81 1.387 4.915.866c1.105-.52 2.863-4.088 2.863-4.088s1.714 3.675 2.863 4.089 4.915-.867 4.915-.867-1.386 3.811-.866 4.916c.52 1.104 4.088 2.863 4.088 2.863s-3.675 1.714-4.088 2.863c-.413 1.148.866 4.915.866 4.915s-3.81-1.387-4.915-.867-2.863 4.088-2.863 4.088-1.714-3.675-2.863-4.088-4.915.866-4.915.866 1.386-3.81.866-4.915S1 1040.363 1 1040.363s3.675-1.714 4.088-2.863z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLeak);
export default ForwardRef;